<template>
  <div>
    <Title :title="'充电机电量数据'"></Title>
    <div class="flex justify-around margin-40">
      <div class="flex align-center">
        <div class="avatar"><img src="@/assets/images/battery/icon0.png"></div>
        <div class="flex flex-direction color-blue justify-center">
          <p class="counts">{{totalElectricityQuantity&&parseFloat(totalElectricityQuantity).toFixed(2)}}</p>
          <p>累计电量</p>
        </div>
      </div>
      <div  class="flex align-center">
        <div class="avatar"><img src="@/assets/images/battery/icon0.png"></div>
        <div class="flex flex-direction color-blue justify-center">
          <p class="counts">{{sameMonthTotalElectricityQuantity&&parseFloat(sameMonthTotalElectricityQuantity).toFixed(2)}}</p>
          <p>当月电量</p>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import Chart from '../gauge.vue'
import Title from '../../title.vue'
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
        sameMonthTotalElectricityQuantity:'',
        totalElectricityQuantity:'',
        height:'180',
        width:'250',
        cdata1:{
            id:"battery1",
            max:10000,
            data:[
                {
                  name:"总电量",
                  value: 6899
                }
            ]
        },
        cdata2:{
            id:"battery2",
            max:1000,
            data:[
                {
                  name:"分电量",
                  value: 699
                }
            ]
        },
        info:"",
    };
  },
  components: {
    Chart,
    Title
  },
  watch: {

  },
  methods: {
    getData(data){
      this.getStationNum(data)
  },
  getStationNum(data={}){
      let _this = this;
      dataInterface
        .dataFaceApi({
          "enCode":"genjustationidfanhuinum",
          "@station_id":_this.$route.query.stationId,
      })
        .then((res) => {
          if (!res) return;
          _this.selectinformationdata(data,res[0].station_num)
        })
        .catch((err) => {
          console.log(err);
        });
    },
  selectinformationdata(data={},num){
      let _this = this;
      let date = new Date();
      let year = date.getFullYear();
      let mouth = date.getMonth()+1;
      mouth = mouth.length>1?mouth:"0"+mouth;
      //TD-电池箱-累计电量
      dataInterface
        .dataFaceApi({
          'enCode':'TD-dianchixiang-leijidianliang',
          '@station_num':num
        })
        .then((res) => {
          if(!res) return;
          console.log("累计电量",res)
          this.totalElectricityQuantity = res[0].totalelectricityquantity;
        })
        .catch((err) => {
          console.log(err);
        });
      //TD-电池箱-当月电量
      dataInterface
        .dataFaceApi({
          'enCode':'TD-dianchixiang-dangyuedianliang',
          '@station_num':num,
          "@cur_date":year+"-"+mouth+"-01 00:00:00"
        })
        .then((res) => {
          if(!res) return;
          console.log("当月电量",res)
          this.sameMonthTotalElectricityQuantity = res[0].samemonthtotalelectricityquantity;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  }
  
}
</script>
<style lang="scss" scoped>
.color-blue{
  color:#0DA6E1;
  font-size:18px;
}
.avatar{
  width:70px;
  height:70px;
  margin-right:10px;
  img{
    width:100%;
    height:100%;
  }
}
.margin-40{
  margin:40px 0;
}
.counts{
  color:#fff;
  font-size:36px;
}
</style>